module.exports = __webpack_public_path__ + "static/media/logo.09a34db4.png";